(function ($) {
    'use strict';

    window.Curtin = window.Curtin || {};
    window.Curtin.Design = window.Curtin.Design || {};
    window.Curtin.Design.Ripple = function (scope) {
        scope = scope || document;

        var buttons = scope.querySelectorAll('.button--ripple, .has-ripple');
        for (var i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('mousedown', function (e) {
                var ripple = document.createElement('span');
                ripple.classList.add('ripple');

                var rect = this.getBoundingClientRect();
                var size = Math.max(rect.width, rect.height);
                var x = e.clientX - rect.left - size / 2;
                var y = e.clientY - rect.top - size / 2;

                ripple.style.width = ripple.style.height = size + 'px';
                ripple.style.left = x + 'px';
                ripple.style.top = y + 'px';

                this.appendChild(ripple);

                setTimeout(function () {
                    ripple.remove();
                }, 600);
            });
        }
    };
})(window.jQuery);

